module.exports = __webpack_public_path__ + "media/images/flags/4x3/ven-42c44704cd1bfe413e41cc5c8db35503.svg";